import React from 'react';

export const FiltersCacheContext = React.createContext({});
